import { path } from 'ramda'
import Smartlook from '@/lib/analytics/smartlook.js'

export default class SmartlookBusiness extends Smartlook {
  eventLogoutHandler () {
    this.anonymize()

    return this.sendingSkipped
  }

  eventOnboardingNewEmailEnteredHandler ({ user }) {
    const email = path(['email'], user)

    this.setRecord({ email, isRawEmail: true })

    return this.sendingSkipped
  }
}
